/**
 *
 * Asynchronously loads the component for VolunteerDetail
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
